import React from 'react';
import { CiSearch } from 'react-icons/ci';

interface SearchBarProps {
    searchTerm: string;
    setSearchTerm: (value: string) => void;
}

const SearchBar = ({ searchTerm, setSearchTerm }: SearchBarProps) => {
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };

    return (
        <div className="relative">
            <input
                type="text"
                className="form-control me-2 2xl:search-box lg:search-box-lg px-4 py-2"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange}
            />
            <CiSearch className="absolute top-1/2 transform -translate-y-1/2 ms-2" />
        </div>
    );
};

export default SearchBar;
